import Current from "@hydrologiq/shared/figures/generic/Current"
import { isCompactFigure } from "@hydrologiq/shared/figures/generic/figureVariant"

interface HeadlineFigureData {
  value: number | null
  unit: string | null
  label: string
  available: boolean
  lastUpdated?: string | null
  metadata?: any
}

interface StateOfChargeFigureProps {
  data: HeadlineFigureData
  loading?: boolean
  error?: string
}

function StateOfChargeFigure({ data, loading, error }: StateOfChargeFigureProps) {
  // Extract additional battery info from metadata
  const storedEnergy = data.metadata?.stored_energy ?? undefined
  const maxCapacity = data.metadata?.max_capacity ?? undefined
  
  // Format secondary info if available
  let secondary: string | undefined
  if (storedEnergy !== undefined && maxCapacity !== undefined) {
    secondary = `${storedEnergy.toFixed(1)} / ${maxCapacity.toFixed(1)} kWh`
  }

  return (
    <Current
      heading={data.label}
      current={data.value ?? undefined}
      unit={data.unit ?? "%"}
      secondary={secondary}
      loading={loading}
      isPlaceholder={!data.available || error !== undefined}
      compact={isCompactFigure("summary")}
    />
  )
}

export default StateOfChargeFigure
